<header color="primary">
  <ion-row>
    <ion-col size-sm="6" size-xs="6" class="title2"> Producto </ion-col>
    <ion-col size-sm="6" size-xs="6" class="title2"> Ventas totales </ion-col>
  </ion-row>
</header>
<ion-grid>
  <!-- Lista de comisiones -->
  <ng-container>
    <ion-row
      class="product-row"
      [ngClass]="{ even: i % 2 === 0 }"
      *ngFor="let item of ambassadorProducts; let i = index"
    >
      <ion-col size-sm="6" class="regularText ion-align-items-center ion-justify-content-center displayFlex">
        <div class="img-container">
          <img [src]="item.pictureUrl" />
        </div>
        <span class="title2 title">{{ item.title }}</span>
      </ion-col>
      <ion-col class="title2 title" size-sm="6"> {{ item.soldQty }} ventas </ion-col>
    </ion-row>
  </ng-container>
</ion-grid>
